import { CommandCenterViewModel } from "./CommandCenterView.model";

export class CommandCenterView extends CommandCenterViewModel {
    toUrlSearchParams(): URLSearchParams {
        const params = new URLSearchParams();
        params.append("view", this.id.toString());
        return params;
    }
}
